goog.provide('el8.ptdata.model.letterAttachment');

goog.require('el8.model.base');

/**
 * This model is used to hold the list of attachments for both letters
 * and letterReceipts. It is technically backed by two separate models
 * on the server (LetterAttachment and LetterReceiptAttachment).
 */
(function() {

    var MAX_SUMMARY_LEN = 100;

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    // for Letters, this will be 'Entity' or a printout type;
    // for LetterReceipts, it can have a little more detail (like 'Report')
    _class.addStringProperty('attachmentType', true);
    _class.addStringProperty('entityDescription', true); // formatted model class, for entities (like 'Lab Report')
    _class.addStringProperty('summary', true); // description of contents (like 'cmp, rbc')
    _class.addDateTime('entityDate', false); // documentDate of original attachment
    _class.addBoolean('confidential', true);
    _class.addIntProperty('printableId', false); // the DocFile id for the PDF
    _class.addIntProperty('entityId', true); // the report id, if this attachment has been filed

    _class.prototype.asMap = function() {
        var result = this.parent.asMap.call(this, true, false);

        result['summary'] = this.getSummary().substring(0, MAX_SUMMARY_LEN);

        return result;
    };

    /* Return either the attachment type for printouts or the entity id for documents/handouts.
     * These would be the attachment's "id" before attachments had their own models.
     * This won't be very useful for LetterReceipts, because the attachment type will never be 'Entity' */
    _class.prototype.getAttachmentKey = function() {
        if (this.getAttachmentType() !== 'Entity') {
            return this.getAttachmentType();
        }
        return this.getEntityId();
    };

    el8.ptdata.model.letterAttachment = function(spec) { return new _class(spec); };

})();


